import { render, staticRenderFns } from "./DogCreate.vue?vue&type=template&id=3ed4c8e6&"
import script from "./DogCreate.vue?vue&type=script&lang=js&"
export * from "./DogCreate.vue?vue&type=script&lang=js&"
import style0 from "./DogCreate.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports